import "./recorder.css";

/**
 * Recorder button — sits to the left of the Finish button in the consultation
 * toolbar. Mic-pill visual ported from ai-medical-consultation-assistant. The
 * animated connector line lives inside the timeline section (RecorderSuggestionsPanel).
 */
export default function RecorderButton({ recorder, disabled }) {
  if (!recorder) return null;

  const { isRecording, toggleRecording } = recorder;

  return (
    <div className="rec-connector-wrap" style={{ marginRight: 8 }}>
      <button
        type="button"
        className={`rec-mic-pill ${isRecording ? "rec-mic-pill--live" : ""}`}
        onClick={toggleRecording}
        disabled={disabled}
        aria-pressed={isRecording}
        aria-label={isRecording ? "Stop recording" : "Start recording"}
        style={{
          gap: "23px",
          marginTop: "29px",
          height: "53px",
          marginLeft: "-75px",
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="9" y="2" width="6" height="12" rx="3" fill="currentColor" />
          <path
            d="M5 11a7 7 0 0 0 14 0M12 18v3"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
        <svg
          className="rec-mic-pill__wave"
          width="34"
          height="16"
          viewBox="0 0 34 16"
          fill="none"
          aria-hidden="true"
        >
          <polyline
            points="0,8 7,8 10,2 13,14 16,8 22,8 25,4 28,12 31,8 34,8"
            stroke="currentColor"
            strokeWidth="1.6"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="rec-mic-pill__dot" />
      </button>
    </div>
  );
}
